import * as React from "react";
import { APINames } from "../../legacy/api/api.names";
import { AutoplayStartButton } from "./components/AutoplayStartButton";
import { NextButton } from "./components/NextButton";
import { PreviousButton } from "./components/PreviousButton";
import { StyledCloseButton } from "./components/StyledCloseButton";
import { Wrapper } from "./components/Wrapper";

export interface ISettingsWindowsCloseButtonMobile {
  onClose?: any;
  allowAutoplayStart?: boolean;
  previousOnClick?: React.EventHandler<React.TouchEvent>;
  nextOnClick?: React.EventHandler<React.TouchEvent>;
  autoplayButtonVisible?: boolean;
}

export const SettingsWindowsCloseButtonMobile = ({
  onClose,
  allowAutoplayStart,
  previousOnClick,
  nextOnClick,
  autoplayButtonVisible,
  ...props
}: ISettingsWindowsCloseButtonMobile) => {
  return (
    <Wrapper {...props}>
      {previousOnClick && <PreviousButton onClick={previousOnClick} />}
      {nextOnClick && <NextButton onClick={nextOnClick} />}
      {autoplayButtonVisible && (
        <AutoplayStartButton
          apiName={APINames.AUTOPLAY_START_BUTTON}
          disabled={!allowAutoplayStart}
        />
      )}
      <StyledCloseButton
        apiName={APINames.AUTOPLAY_CLOSE_BUTTON}
        onClick={onClose}
      />
    </Wrapper>
  );
};
